import { mutate } from 'swr';

import myShopClient from './nearlive';

/**
 * Update the enabled channels object for a given list of stock items in a shop.
 *
 * @param {string} shopId Shop ID
 * @param {string[]} barcodes List of barcodes to update
 * @param {Object<string, boolean>} newChannels New channels object
 * @return {Promise<void>}
 */
export const updateChannelsForStockItems = async (shopId, barcodes, newChannels) => {
	const client = await myShopClient();

	const url = shopId ? `/api/inventory/channels/${shopId}` : `/api/inventory/channels`;
	await client.put(url, { newChannels, barcodes });

	await mutate(`stock_data-${shopId}-${barcodes[0]}`);
};

export const getChannelsForStockItem = (shopId, stockItem, channels) =>
	channels
		?.filter(({ enabledShops }) => (shopId ? enabledShops.some((id) => id === shopId) : enabledShops.length > 0))
		.filter(({ productSpecificVisibility }) => productSpecificVisibility)
		.map(({ id, label }) => {
			return {
				id,
				label,
				enabled: stockItem.channels?.[id] !== false,
				errors: stockItem.issueDefinitions?.filter((issue) => {
					return issue.channels?.[id]?.severity === 'error';
				}),
				warnings: stockItem.issueDefinitions?.filter((issue) => {
					return issue.channels?.[id]?.severity === 'warning';
				})
			};
		})
		.sort((a, b) => {
			if (a.enabled === b.enabled) {
				return a.label.localeCompare(b.label);
			}
			return a.enabled > b.enabled ? -1 : 1;
		});

export const getChannelsForStockItems = (shopId, stockItems, channels) =>
	channels
		?.filter(({ enabledShops }) => enabledShops.some((id) => id === shopId))
		.filter(({ productSpecificVisibility }) => productSpecificVisibility)
		.map(({ id, label }) => {
			return {
				id,
				label,
				enabled: stockItems.some(
					(stockItem) => stockItem.channels?.includes?.(id) || stockItem.channels?.[id] !== false
				)
			};
		})
		.sort((a, b) => {
			if (a.enabled === b.enabled) {
				return a.label.localeCompare(b.label);
			}
			return a.enabled > b.enabled ? -1 : 1;
		});
